import React, { Component } from 'react';
import './App.css';
import Resultat from './Composants/Resultat';
import ChoixInitial from './Composants/ChoixInitial';
import SituationFamiliale from './Composants/SituationFamiliale';
import UnAvis from './Composants/UnAvis';
import DeuxAvis from './Composants/DeuxAvis';

class App extends Component {

    constructor (props){
        super (props);

        this.tranches = [
            { id: 1, mini: 0,       maxi: 4800,     montantFamille: 20,     montantDepartement: 540},
            { id: 2, mini: 4801,    maxi: 5800,     montantFamille: 50,     montantDepartement: 510},
            { id: 3, mini: 5801,    maxi: 7000,     montantFamille: 90,     montantDepartement: 470},
            { id: 4, mini: 7001,    maxi: 8400,     montantFamille: 140,    montantDepartement: 420},
            { id: 5, mini: 8401,    maxi: 10200,    montantFamille: 200,    montantDepartement: 360},
            { id: 6, mini: 10201,   maxi: 12600,    montantFamille: 270,    montantDepartement: 290},
            { id: 7, mini: 12601,   maxi: 16600,    montantFamille: 350,    montantDepartement: 210},
            { id: 8, mini: 16601,   maxi: Infinity, montantFamille: 440,    montantDepartement: 120},                                                                                    
        ];     

        this.state = {
            // navigation
            etape: "initial",
            precedent: "initial",

            // données saisies
            avis: null,
            tranche: 0,
            situationFamiliale: this.situationFamilialeVide(),
        };
    }

    situationFamilialeVide () {
        return { id: 0, revenu1: 0, parts1: 0, revenu2: 0, parts2: 0 };
    }    
    

    elementsChange (event) {
        const { situationFamiliale, etape } = this.state;
        let situation = {};

        switch ( event.type){

            case "reinit":
                switch (event.valeur){
                    case "initial":
                        this.setState ( { etape: "initial", precedent: "initial", avis: null, tranche: 0, situationFamiliale: this.situationFamilialeVide() } );
                        break;
                    case "situation" :
                        this.setState ( { etape: "situation", precedent: "initial", tranche: 0, situationFamiliale: this.situationFamilialeVide() } );
                        break;
                    default:
                        break;
                }
                break;
            case "retour":
                if (etape==="resultat"){
                    this.setState ( { precedent: "initial", etape: "initial"} );
                } else {
                    if (etape === "initial") this.setState ( { precedent: "initial", etape: "initial"} );
                    else {
                        if (etape === "situation"){
                            this.setState ( { precedent: "initial", etape: "initial"} );
                        } else {
                            this.setState ( { precedent: "initial", etape: "situation"} );
                        }
                    }
                }
                this.setState( );
                break;
            case "suivant" : 
                this.setState ( {precedent: etape, etape: event.cible } );
                break;
            case "avis":
                if (!event.valeur) {
                    // la famille ne souhaite pas transmettre son avis, elle est en tranche 8
                    this.setState ( { 
                        avis : false, 
                        tranche: 8 , 
                        situationFamiliale: this.situationFamilialeVide(),
                    });
                } else {
                    // la famille souhaite transmettre ses revenus, on lui demande des informations
                    this.setState ( { avis : true, tranche: 0, situationFamiliale: this.situationFamilialeVide() } );
                }
                break;

            case "situationFamiliale":
                
                switch (event.valeur){
                    case 1 :
                        this.setState ( { tranche: 0, situationFamiliale: { id: event.valeur, revenu1: 0, parts1: 0, revenu2: 0, parts2: 0} });
                        break;                        
                    case 2 :
                        this.setState ( { tranche: 0, situationFamiliale: { id: event.valeur, revenu1: 0, parts1: 0, revenu2: 0, parts2: 0} });
                        break;
                    case 3 :
                        this.setState ( { tranche: 0, situationFamiliale: { id: event.valeur, revenu1: 0, parts1: 0, revenu2: 0, parts2: 0} });
                        break; 
                    case 4 : 
                        this.setState ( { tranche: 0, situationFamiliale: { id: event.valeur, revenu1: 0, parts1: 0, revenu2: 0, parts2: 0} });                       
                        break;
                    default :
                        break;
                }
                break;   

            case "revenu1":
                situation = situationFamiliale;
                situation.revenu1 = event.valeur;
                this.setState ( {situationFamiliale: situation, tranche: this.calculTranche() });
                break;
    
            case "parts1":
                situation = situationFamiliale;
                situation.parts1 = event.valeur;
                this.setState ( {situationFamiliale: situation, tranche: this.calculTranche() });
                break;    

            case "revenu2":
                situation = situationFamiliale;
                situation.revenu2 = event.valeur;
                this.setState ( {situationFamiliale: situation, tranche: this.calculTranche() });
                break;

            case "parts2":
                situation = situationFamiliale;
                situation.parts2 = event.valeur;
                this.setState ( {situationFamiliale: situation, tranche: this.calculTranche() });
                break;                              
            default:
                break;
        }
    };

    /**
     * Calcule la tranche en fonction de deux principaux éléments du state :
     * - l'avis si il est fourni
     * - la situation familiale mentionnée par les personnes
     */
    calculTranche (){
        const { situationFamiliale, avis } = this.state;
        let trancheCalcul = 0;

        if ( avis ){
            // avec avis d'imposition
            if (situationFamiliale.id === 0) {
                // la situationFamiliale n'est pas précisé, la tranche non plus
                trancheCalcul =0;
            } else {
                if ((situationFamiliale.parts1 + situationFamiliale.parts2) !== 0){
                    // au moins un nombre de parts a été donné, on peut calculer la tranche
                    let quotient = this.calculQuotient( situationFamiliale);
                    trancheCalcul = this.getNumeroTranche (quotient);
                } else {
                    // aucune part n'a été mentionnée, on ne calcule pas la tranche
                    trancheCalcul =0;
                }
            }
        } else {
            // sans avis, la tranche est maximale
            trancheCalcul = 8;
        }

        return trancheCalcul;
    }

    /**
     * Calcule le quotient familial ordilot en fonction de la situation familiale
     * @param {object} situationFamiliale 
     */
    calculQuotient (situationFamiliale){
        // polyfill : IE ne supporte pas la commande trunc
        if (!Math.trunc) {
            Math.trunc = function (v) {
                return v < 0 ? Math.ceil(v) : Math.floor(v);
            };
        }
        
        return Math.trunc((parseInt (situationFamiliale.revenu1) + parseInt (situationFamiliale.revenu2)) / ((parseFloat(situationFamiliale.parts1) + parseFloat(situationFamiliale.parts2))));
    }

    /**
     * 
     * @param {int} quotient 
     */
    getNumeroTranche (quotient){
        const { tranches } = this;
        let numeroTranche = 0;

        tranches.forEach( tranche => {
            if (( tranche.mini <= quotient) && ( quotient <= tranche.maxi)) numeroTranche = tranche.id;
        });

        return numeroTranche;
    }    

    render () {
        const { etape, avis, tranche, situationFamiliale } = this.state;
        const { tranches } = this;

        return (
            <div className="App">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            
                            <div className="jumbotron" style = {{ marginTop: "20px"}}>
                                { etape === "initial" && ( <ChoixInitial avis={avis} callback={(event) => this.elementsChange (event)}/> ) }
                                { etape === "situation" && ( <SituationFamiliale situationFamiliale={situationFamiliale} callback={(event) => this.elementsChange (event)}/>)}
                                { etape === "unavis" && ( <UnAvis revenu={situationFamiliale.revenu1} parts={situationFamiliale.parts1} callback={(event) => this.elementsChange (event)} />)}
                                { etape === "deuxavis" && ( 
                                    <DeuxAvis 
                                        revenu1={situationFamiliale.revenu1} 
                                        parts1={situationFamiliale.parts1} 
                                        revenu2={situationFamiliale.revenu2} 
                                        parts2={situationFamiliale.parts2}
                                        callback={(event) => this.elementsChange (event)}/>
                                    )}
                                { etape === "resultat" && ( <Resultat tranche={tranches[tranche-1]} callback={(event) => this.elementsChange (event)} /> ) }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default App;
